import React, { useState } from 'react';
import { Breadcrumb, Card, Spinner, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import BreadcrumbsPortal from '@rd-web-markets/shared/dist/util/BreadcrumbsPortal';
import MasterSidebar from '@rd-web-markets/shared/dist/util/MasterSidebar';
import howToItemService from '@rd-web-markets/shared/dist/services/how_to_item.service';
import HowToItemList from './admin/how_to/HowToItemList';

const HowToPage = ({ accountType, isMyScope = true }) => {
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();

  const { items } = howToItemService.useCrud(setLoading, true);

  return (
    <>
      <BreadcrumbsPortal>
        <Breadcrumb>
          <Breadcrumb.Item linkAs={Link} linkProps={{ to: `/${accountType}` }}>
            {t('home')}
          </Breadcrumb.Item>
          <Breadcrumb.Item active>{t('how_to')}</Breadcrumb.Item>
        </Breadcrumb>
      </BreadcrumbsPortal>

      <Row className='justify-content-center mx-0 mt-4'>
        <Col md={10}>
          <Card className="p-3">
            {loading ? (
              <div className="d-flex justify-content-center p-5">
                <Spinner animation="border" />
              </div>
            ) : (
              <HowToItemList items={items} readOnly={true} />
            )}
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default HowToPage;
